/**
 * A clean, geometric Plus SVG icon.
 */
export const PlusIcon = () => (
    <svg 
        className="w-6 h-6 mr-2" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M12 4v16m8-8H4"
        />
    </svg>
);